import {
  FilterDocument,
  GroupByMode,
  HabitGroupBy,
  HabitSortingMode,
  TaskGroupBy,
  TaskType,
} from '@griply/types';
import { habitSortingModeToSortingMode } from '@griply/utils';

const habitGroupByToGroupByMode: Record<HabitGroupBy, TaskGroupBy> = {
  [HabitGroupBy.None]: GroupByMode.None,
  [HabitGroupBy.Goal]: GroupByMode.Goal,
  [HabitGroupBy.LifeArea]: GroupByMode.LifeArea,
  [HabitGroupBy.Priority]: GroupByMode.Priority,
};

export const buildHabitsFilterDocument = (
  habitGroupBy: HabitGroupBy | undefined,
  habitSortingMode: HabitSortingMode | undefined,
): FilterDocument => ({
  groupByMode: habitGroupBy
    ? habitGroupByToGroupByMode[habitGroupBy]
    : GroupByMode.None,
  sortingMode: habitSortingMode
    ? habitSortingModeToSortingMode[habitSortingMode]
    : null,
  showCompleted: false,
  // Hide only ended habits (`completedAt`); keep today-complete habits visible.
  showCompletedForDate: true,
  filters: { type: { include: [TaskType.Habit] } },
});
